module.exports = __webpack_public_path__ + "img/turnLight.ab34cf12.png";